module.exports = __webpack_public_path__ + "img/img14.275f7b67.svg";